import type { RGB } from "./rgba-color/rgb-color";
import type { RGBA } from "./rgba-color/rgba-color";

const parseRgbaRegEx =
    /^rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(,(\d{1,3})%)?\)$/i;
const parseCssRgba = (rgba: string): RGBA => {
    const parseResult = parseRgbaRegEx.exec(rgba.replace(/\s/g, ""));
    parseRgbaRegEx.lastIndex = 0;
    if (!parseResult) throw new Error("Bad rgb/rgba value: " + rgba);

    const red = parseInt(parseResult[1], 10);
    const green = parseInt(parseResult[2], 10);
    const blue = parseInt(parseResult[3], 10);

    const alpha = (parseResult[5] && parseInt(parseResult[5], 10) / 100) || 1;

    return { red, green, blue, alpha };
};

const parseCssRgb = (rgb: string): RGB => {
    const rgba = parseCssRgba(rgb);
    const { red, green, blue } = rgba;
    return {
        red,
        green,
        blue,
    };
};

export { parseCssRgb, parseCssRgba };
